import { Anchor, AnchorExtendedProps } from 'grommet/components/Anchor';
import React from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';

export const AnchorLink: React.FC<AnchorLinkProps> = ({ to, end, ...props }) => {
  return (
    <NavLink to={to} end={end !== true}>
      {({ isActive }) => (
        <Anchor
          {...props}
          alignSelf='start'
          as={'span'}
          color={isActive ? props.activeColor ?? props.color : props.color}
        />
      )}
    </NavLink>
  );
};

export type AnchorLinkProps = NavLinkProps & AnchorExtendedProps & { activeColor?: string };
